/** @jsx jsx */
import React from "react";
import PropTypes from "prop-types";
import { jsx, css } from "@emotion/core";
import { Link } from "react-router-dom";

import { colors } from "../../theme";
import Logo from "../../components/Logo";
import Cookies from "js-cookie";

const HeaderContainer = ({ children }) => (
    <header
        css={css`
            display: flex;
            padding: 20px 40px 0 40px;
        `}
    >
        {children}
    </header>
);

const DummyFlexElement = () => (
    <div
        css={css`
            flex: 1;
            @media (min-width: 521px) {
                display: none;
            }
        `}
    />
);

const LogoContainer = ({ children }) => (
    <div
        css={css`
            flex: 1;
            display: flex;
            justify-content: start;
            @media (max-width: 520px) {
                justify-content: center;
            }
        `}
    >
        {children}
    </div>
);

const CloseButton = () => (
    <div
        css={css`
            flex: 1;
        `}
    >
        <a
            data-testid="close-button"
            css={css`
                font-size: 36px;
                align-self: center;
                color: ${colors.neutral6};
                float: right;
                text-decoration: none;
            `}
            href={
                "/programme-setup/pupil-information/?id=" +
                Cookies.get("programmeId")
            }
        >
            &#215;
        </a>
    </div>
);

const ExcelHeader = ({ children }) => (
    <HeaderContainer>
        <DummyFlexElement />
        <LogoContainer>
            <Logo />
        </LogoContainer>
        {children}
        <CloseButton />
    </HeaderContainer>
);

export default ExcelHeader;
